import React, { useState } from "react";
import axios from "axios";
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import Form from 'react-bootstrap/Form';
import { Row, Col } from 'react-bootstrap';

function  EnquirePopupFrom(props) {
  const handleMobileKeyPress = e => {
    const mobileValue = e.target.value;
    if (mobileValue.length >= 10) {
      e.preventDefault();
    }
  };
  const [formData, setFormData] = useState({
      name: "",
      email: "",
      mobile: "",
      whoareyou: "",
      message: "",
  });
  const [errors, setErrors] = useState({});
  const [isLoading, setIsLoading] = useState(false);

  const handleChange = e => {
      const { name, value } = e.target;
      setFormData(prevData => ({ ...prevData, [name]: value }));
      setErrors(prevErrors => ({ ...prevErrors, [name]: "" }));
  };

  const validateForm = () => {
      const validationErrors = {};

      if (!formData.name) {
          validationErrors.name = "Name is required";
      }

      if (!formData.email) {
          validationErrors.email = "Email is required";
      } else if (!/\S+@\S+\.\S+/.test(formData.email)) {
          validationErrors.email = "Invalid email format";
      }

      if (!formData.mobile) {
          validationErrors.mobile = "Mobile number is required";
      } else if (!/^\d{10}$/.test(formData.mobile)) {
          validationErrors.mobile = "Invalid mobile number";
      }

      if (!formData.whoareyou) {
          validationErrors.whoareyou = "Select an option";
      }

      return validationErrors;
  };

  const handleSubmit = async e => {
      e.preventDefault();
      const validationErrors = validateForm();
      if (Object.keys(validationErrors).length === 0) {
          setIsLoading(true);  
          try {
            await axios.post(`https://www.ueducate.in:3001/send-email`, {
                  name: formData.name,
                  email: formData.email,
                  mobile: formData.mobile,
                  whoareyou: formData.whoareyou,
                  message: formData.message,
                  subject: "Enquiry Form",
              });
              setFormData({
                  name: "",
                  email: "",
                  mobile: "",
                  whoareyou: "",
                  message: "",
              });
              alert("Email sent successfully");
          } catch (error) {
              alert("An error occurred while sending the email");
          }
          setIsLoading(false);
      } else {
          setErrors(validationErrors);
      }
  };

  return (
 
    <div>
        <Modal
      {...props}
      size="xl"
      aria-labelledby="contained-modal-title-vcenter"
      centered className='enqnowPopup'
    >
      <Modal.Header closeButton>
        
      </Modal.Header>
      <Modal.Body>
        <Row>
          <Col md='5'><img src={require('../asstes/images/PopEnquireNowImg.jpg')} alt='Enquire Now' /></Col>
          <Col md='7'>
            <div className='popformcol'>
              <h3>Enquire Now</h3>
              <Form noValidate onSubmit={handleSubmit}>
                <Row>
                  <Col md='6'>
                    <Form.Group className="mb-5 posrel" controlId="formBasicName">
                        <Form.Label>Name</Form.Label>
                        <Form.Control type="text" name="name" placeholder="Name" value={formData.name} onChange={handleChange} required/>
                          {errors.name && <p className='field-error'>{errors.name}</p>}
                    </Form.Group>
                  </Col>
                  <Col md='6'>
                    <Form.Group className="mb-5 posrel" controlId="formBasicEmail">
                        <Form.Label>Email address</Form.Label>
                        <Form.Control type="email" name="email" placeholder="Enter email" value={formData.email} onChange={handleChange} required/>
                          {errors.email && <p className='field-error'>{errors.email}</p>}
                    </Form.Group>
                  </Col>
                  <Col md='6'>
                    <Form.Group className="mb-5 posrel" controlId="formBasicPhone">
                        <Form.Label>Phone Number</Form.Label>
                        <Form.Control type="tel" name="mobile" placeholder="Phone Number" value={formData.mobile} onChange={handleChange} onKeyPress={handleMobileKeyPress} required/>
                          {errors.mobile && <p className='field-error'>{errors.mobile}</p>}
                    </Form.Group>
                  </Col>
                  <Col md='6'>
                    <Form.Group className="mb-5 posrel" controlId="formBasicPhone">
                        <Form.Label>Are You A</Form.Label>
                        <Form.Select name="whoareyou" aria-label="Default select example" value={formData.whoareyou} onChange={handleChange} required>
                          <option value="">Select Who You Are</option>
                          <option value="Student">Student</option>
                          <option value="Teacher">Teacher</option>
                          <option value="Institution">Institution</option>
                          <option value="Academy">Academy</option>
                          <option value="University">University</option>
                          <option value="Corporate">Corporate</option>
                          <option value="Publisher">Publisher</option>
                          <option value="Content Creator">Content Creator</option>
                        </Form.Select> 
                          {errors.whoareyou && <p className='field-error'>{errors.whoareyou}</p>}
                    </Form.Group>
                  </Col>
                  <Col md='12'>
                    <Form.Group className="mb-4 posrel" controlId="formBasicPhone">
                        <Form.Label>Message</Form.Label>
                        <Form.Control as="textarea" name="message" rows={2} placeholder="Message" value={formData.message} onChange={handleChange}/>
                    </Form.Group>
                  </Col>
                  <Col md='12' className='lastCol'>
                    <Button variant="primary" type="submit" disabled={isLoading}>{isLoading ? 'Submitting...' : 'Submit'}</Button>
                  </Col>
                </Row>
              </Form>
            </div>
          </Col>
        </Row>
      </Modal.Body>
    </Modal>


    </div>
  )
}

export default EnquirePopupFrom